import React from 'react'
import Wow from 'wowjs'
import { useEffect } from 'react';


export default function About() {
    var wow = new Wow.WOW({live: false});

    useEffect(()=>{
      wow.init();
    }, )
   
  return (
    <div className='about pt-4 pb-1 px-2 d-flex justify-content-center' id='about'>
      <div className='col-md-10 col-lg-9 col-xl-8 pt-5 bg-dange d-flex flex-column'>
      <section className='about-header'>
        <h4 className='header-text text-uppercase wow slideInLeft'>Meet Mwangi</h4>
    </section>
    <section className='mt-3 px-2 pb-2 wow slideInUp paragraph'>
        I build responsive designs using React JS and currently work extensively with Next JS for scalable web applications. As I advance, my work is increasingly driven by a commitment to <span className='highlight'>systems design</span>, <span className='highlight'>Machine Learning </span> and <span className='highlight'>Brain Computer Interfaces (BCI)</span>.
<br></br><br></br>
        My long term vision is to contribute to the development of intelligent systems that enhance human potential particularly in cognitive augumentation, behavior-aware AI and ethical machine interaction.
    </section>
    <section className='princples px-1 p-2 my-3 text-light text-center d-flex flex-wrap justify-content-between'>
      <section className='moral wow slideInUp mt-3'>
        <section className='moral-header d-flex gap-2 align-items-center align-content-center heading'>
          <p className='moral-label d-flex justify-content-center align-items-center '>1</p>
          <p className='moral-title d-flex justify-content-center align-items-center'>Systems-Oriented Thinking</p>
        </section>
        <p className='moral-description text-start mx-4 px-2 pt-2 paragraph'>
          I approach every problem with long term mindset; designing software not just to work but to scale and adapt.
        </p>

      </section>
      <section className='moral wow slideInUp mt-3'>
        <section className='moral-header d-flex gap-2 align-items-center align-content-center heading'>
          <p className='moral-label d-flex justify-content-center align-items-center '>2</p>
          <p className='moral-title d-flex justify-content-center align-items-center'>Curiosity-Driven Learning</p>
        </section>
        <p className='moral-description text-start mx-4 px-2 pt-2 paragraph'>
          My exploration into system design and Machine Learning fuels my growth across disciplines.
        </p>

      </section>
      <section className='moral wow slideInUp mt-3'>
        <section className='moral-header d-flex gap-2 align-items-center align-content-center heading'>
          <p className='moral-label d-flex justify-content-center align-items-center '>3</p>
          <p className='moral-title d-flex justify-content-center align-items-center'>Human-Centered Engineering</p>
        </section>
        <p className='moral-description text-start mx-4 px-2 pt-2 paragraph'>
          I believe all technology should serve humans; whether it's a User Interface or a Machine learning model. 
          </p>
      </section>
      <section className='moral wow slideInUp mt-3'>
        <section className='moral-header d-flex gap-2 align-items-center align-content-center heading'>
          <p className='moral-label d-flex justify-content-center align-items-center '>4</p>
          <p className='moral-title d-flex justify-content-center align-items-center '>Technical Integrity</p>
        </section>
        <p className='moral-description text-start mx-4 px-2 pt-2 paragraph'>
        I prioritize architecture, code quality and security. I build with discipline knowing that stable systems come from strong fundamentals.
        </p>

      </section>
      
      
    </section>
    <section className='call text-start pt-2 wow slideInUp mt-3 align-self-md-center paragraph'>
        <p className='mb-1'><span className='highlight'>Call or Whatsapp:</span> (254)701414212</p>
        <p className='mb-1'><span className='highlight'>Email:</span> meetmwangi@gmail.com</p>
      </section>
    
      </div>

    </div>
  )
}
